import { Outlet } from "react-router-dom";

export const DummyLayout = () => {
  return <Outlet />;
};
